/**
 * Vacancy Filter
 *
 * This component requires jQuery and Slick to function.
 * You can require it on the page using <div data-component="vacancy-filter"></div>
 */
$(function () {
  $('[data-component="vacancy-filter"]').each(function () {
    let $holder = $(this);
    $('.btn-load-more', $holder).click(function (e) {
      e.preventDefault();
      var selected_city = $("#vacancy_city").val();
      var selected_dept = $("#vacancy_dept").val();
      var button = $(this),
          data = {
        'action': 'vacancies',
        'limit': limit,
        'page': page,
        'selected_dept': selected_dept,
        'selected_city': selected_city
      };
      var maxpage = max_pages_latest;
      $.ajax({
        url: vacancies_params.ajaxurl,
        data: data,
        type: 'POST',
        beforeSend: function (xhr) {
          button.text('Loading...'); // change the button text, you can also add a preloader image
        },
        success: function (data) {
          if (data) {
            $(".vacancies-section__list").append(data);
            button.text('Load More');

            if (page >= maxpage) {
              button.remove();
            } // if last page, remove the button

          } else {
            button.remove(); // if no data, remove the button as well
          }

          page++;
        }
      });
    });
    $('#vacancy_city', $holder).change(function (e) {
      e.preventDefault();
      var selected_city = $("#vacancy_city").val();
      var selected_dept = $("#vacancy_dept").val();
      var button = $('.btn-load-more'),
          data = {
        'action': 'vacancies',
        'limit': limit,
        'page': 1,
        'dept': selected_dept,
        'city': selected_city
      };
      $.ajax({
        url: vacancies_params.ajaxurl,
        data: data,
        type: 'POST',
        beforeSend: function (xhr) {
          $(".vacancies-section__list").html('Loading...'); // change the button text, you can also add a preloader image
        },
        success: function (data) {
          if (data) {
            $(".vacancies-section__list").html(data);
            button.text('Load More');

            if (page >= max_pages_latest) {
              button.hide();
            } else {
              button.show();
              page = 2;
            } // if last page, remove the button

          } else {
            button.hide(); // if no data, remove the button as well
          }
        }
      });
    });
    $('#vacancy_dept', $holder).change(function (e) {
      e.preventDefault();
      var selected_city = $("#vacancy_city").val();
      var selected_dept = $("#vacancy_dept").val();
      var button = $('.btn-load-more'),
          data = {
        'action': 'vacancies',
        'limit': limit,
        'page': 1,
        'dept': selected_dept,
        'city': selected_city
      };
      $.ajax({
        url: vacancies_params.ajaxurl,
        data: data,
        type: 'POST',
        beforeSend: function (xhr) {
          $(".vacancies-section__list").html('Loading...'); // change the button text, you can also add a preloader image
        },
        success: function (data) {
          if (data) {
            $(".vacancies-section__list").html(data);
            button.text('Load More');

            if (page >= max_pages_latest) {
              button.hide();
            } else {
              button.show();
              page = 2;
            } // if last page, remove the button

          } else {
            button.hide(); // if no data, remove the button as well
          }
        }
      });
    });
  });
});